import axios from "axios";
import { MeasurandData } from "../../stations/types/stations.types";

import { FilterPoint, Point } from "../../../common/analysis/filter/types/types";

export const BASE_URL_CHARGING_SESSION = process.env.REACT_APP_BACKEND_API_URL + "/api/v1/charging-session";
export const BASE_URL_CHARGING_SESSION_ADMIN = process.env.REACT_APP_BACKEND_API_URL + "/api/v1/admin/charging-session";

export const getChargingSessionDataInflux = async (chargingSession: string, measurand: MeasurandData, filter?: FilterPoint) => {
    const startDate = filter?.startDate || "2025-06-01T00:00:00Z";
    const stopDate = filter?.stopDate || "2025-07-01T00:00:00Z";
    const range = "start=" + startDate + ",stop=" + stopDate;
    const aggregateWindow = filter?.aggregateWindow || undefined;

    const params = "range=" + range + (aggregateWindow ? "&aggregateWindow=" + aggregateWindow : "");

    return (await axios.get<Point[]>(`${ BASE_URL_CHARGING_SESSION_ADMIN}/${chargingSession}/analysis/${measurand}?${params}`)).data;
}

export const syncChargingSessionWithHardTransactionApi = async (chargingSession: string) => {
    return (await axios.get(`${BASE_URL_CHARGING_SESSION_ADMIN}/${chargingSession}/sync`)).data;
}